import AbstractService from "./AbstractService";
import NexusService from "./NexusService";

export default class NonRKPayInvoiceEstimatesService extends AbstractService {
	static estimatesApi = NexusService.nonRKPayInvoiceEstimatesApi;

	static getEstimateInvoiceable(id) {
		return this.estimatesApi.getEstimateInvoiceable({ id }).then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}

	static archiveEstimate(id) {
		return this.estimatesApi.archiveEstimate({ id }).then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}

	static unarchiveEstimate(id) {
		return this.estimatesApi.unarchiveEstimate({ id })
			.then(response => ({ data: response }));
	}

	static getEstimateRefundable(id) {
		return this.estimatesApi.getEstimateRefundable({ id }).then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}

	static refundEstimate(id) {
		return this.estimatesApi.refundEstimate({ id }).then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}

	static getEstimateAvailableFunds(id) {
		return this.estimatesApi.getEstimateAvailableFunds({ id }).then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}

	static finalizeEstimate(id) {
		return this.estimatesApi.finalizeEstimate({ id }).then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		})
	}

	static generateInvoiceFromEstimate({ id, dueDate }) {
		const payload = {
			id,
			nonRKPayInvoiceEstimateGenerateInvoicePayload: {
				DueDate: dueDate
			}
		};

		return this.estimatesApi.generateInvoiceFromEstimate(payload)
			.then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
		})
	}

	static getAssociatedInvoices(id) {
		return this.estimatesApi.getAssociatedInvoices({ estimateId: id })
			.then(response => ({ data: response }));
	}

	static getEstimateActions(id) {
		return this.estimatesApi.getEstimateActions({ estimateId: id })
			.then(response => ({ data: response }));
	}

	static getPaginatedEstimates(queryParams, setCancel ) {
		const controller = new AbortController();

		if (setCancel) setCancel(() => controller.abort());

		return this.estimatesApi.getPaginatedNonRKPayInvoiceEstimatesList(
			queryParams,
			{ signal: controller.signal }
		).then(response => ({ data: response }));
	}

	static regenerateEstimateItems(id) {
		return this.estimatesApi.regenerateEstimateItems({ id }).then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}
}
